export default __webpack_public_path__ + "static/media/soviet_union.89a701cf.svg";